//
// Copyright (c) 2021 Astute Global, Inc.
//

import { Command } from "ckeditor5";

export default class DeleteCustomTemplateCommand extends Command {
  execute(templateOrId) {
    // Must only load the MessengerAdapter using its name, cannot import it
    // otherwise the entire Backbone library will get pulled into the build
    if (!this.editor.plugins.has("MessengerAdapter")) {
      console.error(
        "No MessengerAdapter plugin found to Delete Custom Template, probably in CK Cloud",
      );
      return;
    }
    const messengerAdapter = this.editor.plugins.get("MessengerAdapter");
    messengerAdapter.reqres().request("remove:custom:template", templateOrId);
  }
}
